import { defineComponent, onUpdated, ref } from "vue";
import { currentSiteId } from "@/extensions/extra";
import { ContentModel } from "@/models/content";
import { GET_CONTENT } from "@/services/content-service";
import { returnErrors } from "@/utils/returnErrors";
import { notifyError } from "@/utils/notifier.js";

export default defineComponent({
  name: "Description",
  props: ["originalUrl", "showDialog", "modelValue"],
  emits: ["update:modelValue"],
  components: {},

  setup(props, { emit }) {
    const contentModel = new ContentModel();
    const description = ref();

    onUpdated(() => {
      if (props.modelValue == true) {
        getContent();
      }
    });

    async function getContent() {
      contentModel.currentSiteId = currentSiteId;
      contentModel.originalUrl = props.originalUrl;
      description.value = "";
      const [error, response] = await GET_CONTENT(contentModel);
      if (error) {
        const errorMessage: any = returnErrors(error);
        notifyError(false, errorMessage, "negative", "report_problem");
      } else {
        description.value = response.list.description;
      }
    }

    function closeDescriptionDialog() {
      emit("update:modelValue", false);
    }

    return {
      closeDescriptionDialog,
      getContent,
      currentSiteId,
      props,
      description,
    };
  },
});
